import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import {
    TIEBREAKER_OFFSET,
    TiebreakerScore,
    TiebreakerSize,
    getTiebreakerLayout,
} from '@/components/scoreboard/TiebreakerScore';

const SET_COLUMN_WIDTH = 20;
const SET_COLUMN_GAP = 2;

export type TennisSetScore = {
    score: number | string;
    tieBreak?: number;
    tieBreakSize: TiebreakerSize;
    isWinner?: boolean;
    isActive?: boolean;
};

type TennisScoreboardProps = {
    setScores: TennisSetScore[];
    gameScore?: number | string;
};

const getSpaceAfter = (set: TennisSetScore, isLast: boolean) => {
    const layout = getTiebreakerLayout(set.tieBreakSize, TIEBREAKER_OFFSET, SET_COLUMN_GAP);
    return isLast ? layout.overhang : layout.gapAfter;
};

export const TennisScoreboard = ({ setScores, gameScore }: TennisScoreboardProps) => {
    return (
        <Row alignItems="center">
            {gameScore !== undefined ? (
                <Text variant="titleMedium" color={ds.colorToken.text.primary} textAlign="right" pr="s4">
                    {gameScore}
                </Text>
            ) : null}
            <Row>
                {setScores.map((set, index) => {
                    const isHighlighted = set.isActive || set.isWinner;
                    return (
                        <Box
                            key={index}
                            width={SET_COLUMN_WIDTH}
                            alignItems="center"
                            style={{ marginRight: getSpaceAfter(set, index === setScores.length - 1) }}
                        >
                            <Text
                                variant="bodyMedium"
                                color={isHighlighted ? ds.colorToken.text.primary : 'neutral300'}
                            >
                                {set.score}
                            </Text>
                            {set.tieBreak !== undefined ? (
                                <TiebreakerScore score={set.tieBreak} size={set.tieBreakSize} variant="bodySmall" />
                            ) : null}
                        </Box>
                    );
                })}
            </Row>
        </Row>
    );
};
